.image-container,
.content-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.image-container > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (min-width:1024px) {
  .image-container.right {
    order: 1;
  }
}

:host > cradlepoint-container {
  height: 100%;
}

.content-container {
  display: grid;
  place-items: center;
}

::slotted([slot="title"]) {
  margin-top: auto;
  margin-bottom: 0;
  font-size: 30px;
  line-height: 1.2;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
}

::slotted([slot="description"]) {
  margin-top: 24px;
  margin-bottom: auto;
  font-size: 24px;
  line-height: 1.25;
  font-family: var(--cwc-font-sans-serif-light, 'Eina01-Light');
}
